import React, { Component } from "react";
//import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter,
  Switch
} from "react-router-dom";
import Spinner from "react-spinkit";
import PrivateRoute from "./lib/PrivateRoute";
import Login from "./pages/login/Login";
import SSO from "./pages/login/SSO";
import Dashboard from "./pages/dashboard/Dashboard";
import Agents from "./pages/dashboard/Agents";
import Agent from "./pages/dashboard/Agent";
import Users from "./pages/dashboard/Users";
import User from "./pages/dashboard/User";
import Marketing from "./pages/dashboard/Marketing";
import Settings from "./pages/dashboard/Settings";
import UserSettings from "./pages/dashboard/UserSettings";
import SettingsSSO from "./pages/dashboard/SettingsSSO";
import Preferences from "./pages/dashboard/Preferences";
import Profile from "./pages/dashboard/Profile";
import Pocket from "./pages/dashboard/Pocket";
import PocketEdit from "./pages/dashboard/PocketEdit";
import NoMatch from "./pages/dashboard/NoMatch";
import { Cookies } from "react-cookie";

import api from "./lib/api";
import UserStore from "./stores/UserStore";
import { observer } from "mobx-react";
import AppStore from "./stores/AppStore";

import "react-tippy/dist/tippy.css";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#016aaa"
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    }

    // error: will use the default color
  }
});

@observer
class App extends Component {
  constructor(props) {
    super(props);
    this.state = { on: true, isChecking: true };

    //const cookies = new Cookies();
    //cookies.set("api_key", "12dada", { path: "/", maxAge: 60 * 60 * 24 });
  }

  componentDidMount() {
    const cookies = new Cookies();
    let api_key = cookies.get("bk_api_key");

    if (!api_key) {
      const query = new URLSearchParams(window.location.search);
      api_key = query.get("k");
    }

    if (api_key && !UserStore.hasUser()) {
      AppStore.setAPIKey(api_key);
      // Call the API and get the user info
      this.setState({ isChecking: true });

      api.key(
        {
          api_key: api_key
        },
        response => {
          //alert(JSON.stringify(response));
          UserStore.updateData(response.user);
          //AppStore.getAppData(response.user.stack_id);
          //this.setState({ isChecking: false });

          AppStore.setAppData(response.app);
          this.setState({ isChecking: false });
        },
        error => {
          // Do nothing... it will just go to login then
          this.setState({ isChecking: false });
        }
      );
    } else {
      this.setState({ isChecking: false });
    }
  }

  render() {
    if (this.state.isChecking) {
      return (
        <div
          class="d-flex w-100 justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div class="spinner-border text-warning" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      );
    }

    return (
      <MuiThemeProvider theme={theme}>
        <div className="app">
          <Router>
            <Switch>
              {/*<Route path="/" component={Dashboard} />*/}

              <Route path="/login" component={Login} />
              <Route path="/sso" component={SSO} />
              <Route path="/sso/" component={SSO} />
              <PrivateRoute exact path="/" component={Dashboard} />

              <PrivateRoute path="/agents/:agentId" component={Agent} />
              <PrivateRoute path="/agents" component={Agents} />

              <PrivateRoute path="/users/:userId" component={User} />
              <PrivateRoute path="/users" component={Users} />

              <PrivateRoute path="/marketing" component={Marketing} />
              <PrivateRoute path="/preferences" component={Preferences} />
              <PrivateRoute path="/profile" component={Profile} />
              <PrivateRoute
                exact
                path="/user_settings"
                component={UserSettings}
              />
              <PrivateRoute exact path="/settings" component={Settings} />
              <PrivateRoute path="/settings/sso" component={SettingsSSO} />
              <PrivateRoute exact path="/pocket" component={Pocket} />
              <PrivateRoute exact path="/pocket/new" component={PocketEdit} />
              <PrivateRoute path="/pocket/:listingId" component={PocketEdit} />
              <PrivateRoute component={NoMatch} />
            </Switch>

            {/*<Redirect
          to={{
            pathname: "/login",
            state: {}
          }}
        />

        <Route path="/login" component={Login} />*/}
          </Router>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;
